/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRechercheDateAbsenceDto } from './FcbRechercheDateAbsenceDto';
import {
    FcbRechercheDateAbsenceDtoFromJSON,
    FcbRechercheDateAbsenceDtoFromJSONTyped,
    FcbRechercheDateAbsenceDtoToJSON,
} from './FcbRechercheDateAbsenceDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRechercheDateAbsenceDtoPaginatedResults
 */
export interface FcbRechercheDateAbsenceDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheDateAbsenceDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRechercheDateAbsenceDto>}
     * @memberof FcbRechercheDateAbsenceDtoPaginatedResults
     */
    results?: Array<FcbRechercheDateAbsenceDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRechercheDateAbsenceDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRechercheDateAbsenceDtoPaginatedResults interface.
 */
export function instanceOfFcbRechercheDateAbsenceDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheDateAbsenceDtoPaginatedResultsFromJSON(json: any): FcbRechercheDateAbsenceDtoPaginatedResults {
    return FcbRechercheDateAbsenceDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRechercheDateAbsenceDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheDateAbsenceDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRechercheDateAbsenceDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRechercheDateAbsenceDtoPaginatedResultsToJSON(value?: FcbRechercheDateAbsenceDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRechercheDateAbsenceDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

